import React from 'react';
import { COMMON_ERROR_WRAPPERS } from '../../../studio-blocks/components/error-wrappers/common';
import { MetricsErrorWrapper } from '../../../studio-blocks/components/error-wrappers/MetricsErrorWrapper';
import { Block } from '../../components/core';
import { CorrelationHeader } from './correlation-header';
import { CorrelationContent } from './correlation-content';
import { CorrelationErrorWrapper } from '../../../studio-blocks/components/error-wrappers/CorrelationErrorWrapper';

export const CorrelationBlock = ({ id }: { id: string }) => {
  return (
    <Block.Root id={id}>
      <Block.Header>
        <CorrelationHeader id={id} />
      </Block.Header>

      <Block.Content
        id={id}
        errorWrappers={[
          ...COMMON_ERROR_WRAPPERS,
          // MetricsErrorWrapper is last because it requires analysis, so we might as well do all the client-side error checks first
          MetricsErrorWrapper,
          CorrelationErrorWrapper,
        ]}
      >
        <CorrelationContent id={id} />
      </Block.Content>
    </Block.Root>
  );
};
